import axios from 'axios'
export default {
  namespaced: true,
  state: {
    bulletinArray: [],
    fontColor: [],
    bgColor: []
  },
  actions: {
    getBulletin ({ commit }) {
      let API_PATH = process.env.API
      return axios
        .get(`${API_PATH}bulletin/list`)
        .then((response) => {
          let bulletinArray = response.data.data
          commit('getBulletin', { bulletinArray })
        })
        .catch((error) => {
          if (error.response) {
            console.log(error)
          }
        })
    }
  },
  mutations: {
    getBulletin (state, { bulletinArray }) {
      state.bulletinArray = bulletinArray
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/bulletin.js